import { render, staticRenderFns } from "./VariantSifterLdRegionPlot.vue?vue&type=template&id=6d178325&scoped=true&"
import script from "./VariantSifterLdRegionPlot.vue?vue&type=script&lang=js&"
export * from "./VariantSifterLdRegionPlot.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterLdRegionPlot.vue?vue&type=style&index=0&id=6d178325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d178325",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d178325')) {
      api.createRecord('6d178325', component.options)
    } else {
      api.reload('6d178325', component.options)
    }
    module.hot.accept("./VariantSifterLdRegionPlot.vue?vue&type=template&id=6d178325&scoped=true&", function () {
      api.rerender('6d178325', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterLdRegionPlot.vue"
export default component.exports